export default {
  flexContainer: {
    borderSpacing: 0,
    color: '#333333',
    fontFamily: 'sans-serif',
    width: '100%',
  },
  flexContainerInner: {
    margin: '0 auto',
    borderSpacing: '0',
    maxWidth: '642px',
    width: '100%',
  },
  flexContainerInner_cell: {
    fontSize: '0',
    padding: '0',
    textAlign: 'center',
  },
}
